<template>
  <div
    class="d-flex w-100"
    style="position: absolute; top: 0; justify-content: center; pointer-events: none;"
  >
    <div
      v-for="(error, index) in errors"
      :key="index"
      style="z-index: 6; pointer-events: auto;"
    >
      <div
        v-for="(messages, field) in error"
        :key="field"
        class="mx-4"
      >
        <v-alert
          v-for="(message, messageIndex) in messages"
          :key="messageIndex"
          type="error"
          elevation="2"
          class="my-2"
          rounded="0"
          density="compact"
          closable
          @click:close="clearErrors"
        >{{ message }}</v-alert>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseErrorAlerts',

  computed: {
    errors() {
      return this.$store.state.errors;
    },
  },

  methods: {
    clearErrors() {
      this.$store.dispatch('clearErrors');
    },
  },
};
</script>
